import * as React from 'react';
import autobind from 'autobind-decorator';
import { isArrayLike } from 'mobx';

import { ProductCategoryListDataService } from 'src/app/products/product-categories/list/product-category-list.data';
import { ProductCategoryEditorView } from './product-category-editor.view';

interface ProductCategoryEditorControllerProps {
	value: number|number[] | null;
	mode: ControlMode;
	onChanged?: (value: ProductCategorySummary ) => void;
	multiOnChange?: (values: ProductCategorySummary[]) => void;
	setBusy(isBusy: boolean);
	label?: string;
	productType?: number | number[];
	afterLoad?: (value: any) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	baseCategoriesEnabled?: boolean;
	multi?:boolean
}

export class ProductCategoryEditorController extends React.Component<ProductCategoryEditorControllerProps, {}> {
	protected categoryDataService: ProductCategoryListDataService;

	constructor(props: Readonly<ProductCategoryEditorControllerProps>) {
		super(props);
		this.categoryDataService = ProductCategoryListDataService.make();
	}

	@autobind
	protected productCategoryQuery(q?: string): Promise<QueryResult<ProductCategorySummary>> {
		return new Promise<QueryResult<ProductCategorySummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.categoryDataService.addFilter('isDeleted', 'eq', false);
			this.categoryDataService.addSorting('id', 'asc', true);
			this.categoryDataService.searchKeywords = q;
			const productType = this.props.productType;
			this.categoryDataService
				.load(function (entitySet) {
					if (productType != null) {
						const values = isArrayLike(productType) ? productType : [productType];
						const predicate = values.reduce<string>((prev, curr) => (prev ? (prev + ' || ') : '') + `it.productType == ${JSON.stringify(curr)}`, null);
						return entitySet.filter(predicate);
					}
					return entitySet;
				})
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: (items),
						totalCount: this.categoryDataService.count
					});
				});
		});
	}

	render(): React.ReactNode {
		return (
			<ProductCategoryEditorView
				productType={this.props.productType}
				onGetErrorMessage={this.props.onGetErrorMessage}
				productCategoryRequest={{ query: this.productCategoryQuery, dataSet: this.categoryDataService }}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/parts/product-category-editor.controller.tsx